import {
  BackstageUserIdentity,
  IdentityApi,
  ProfileInfo,
} from '@backstage/frontend-plugin-api';

export interface SignInAuthApi {
  getBackstageIdentity(options?: {
    optional?: boolean;
    instantPopup?: boolean;
  }): Promise<
    | {
        identity: BackstageUserIdentity;
        token: string;
      }
    | undefined
  >;
  getProfile(): Promise<ProfileInfo | undefined>;
  signOut(): Promise<void>;
}

async function optionalProfile(
  authApi: SignInAuthApi,
): Promise<ProfileInfo | undefined> {
  try {
    return await authApi.getProfile();
  } catch {
    return undefined;
  }
}

export function createIdentityApi(
  authApi: SignInAuthApi,
  identity: BackstageUserIdentity,
  initialProfile?: ProfileInfo,
): IdentityApi {
  let profile = initialProfile;

  return {
    async getProfileInfo() {
      profile ??= (await optionalProfile(authApi)) ?? {};
      return profile;
    },
    async getBackstageIdentity() {
      return identity;
    },
    async getCredentials() {
      const response = await authApi.getBackstageIdentity();
      return response ? { token: response.token } : {};
    },
    async signOut() {
      await authApi.signOut();
    },
  };
}

export { optionalProfile };
